module.exports = __webpack_public_path__ + "static/media/Marian Tuin Headshot.42f41788.png";